<template>
  <div class="relative min-h-screen min-w-screen flex flex-col justify-between pb-8">
      <div>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute top-10 mt-2 left-8 cursor-pointer" @click="$router.push({ name: 'Dashboard' }), this.$store.dispatch('setSidebarStatus', true)"><path d="M4 12L20 12M11 5L4 12L11 19" stroke="#223672" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <default-header 
              type="dark"
              :title="$t('helpsectiontitle')"
              textClasses="text-white"
              :masked="false"
              seperatorClasses="bg-gray-500"
              @filteringPasses="changeFilter"
          />
          <div class="px-8 -mt-20">
            <div class="space-y-5 text-primary">
                <h1 class="text-2xl text-center leading-9 font-sans-secondary">{{ $t('faqtitle') }}</h1>
                <img :src="noLightGif" alt="Gif depicting green light shown on the lifepass." class="px-10"> 
                <div>
                    <h2 class="text-base font-sans-secondary mb-2.5">{{ $t('faqsteponetitle') }}</h2>
                    <p class="text-base font-sans-primary"><strong class="font-sans-secondary">{{ $t('faqsteponebold') }}</strong> {{ $t('faqsteponetext') }}</p>
                </div>
                <div>
                    <h2 class="text-base font-sans-secondary mb-2.5">{{ $t('faqsteptwotitle') }}</h2>
                    <p class="text-base font-sans-primary"><strong class="font-sans-secondary">{{ $t('faqsteptwobold') }}</strong> {{ $t('faqsteptwotext') }}</p>
                </div>
                <div>
                    <h2 class="text-base font-sans-secondary mb-2.5">{{ $t('faqstepthreetitle') }}</h2>
                    <p class="text-base font-sans-primary"><strong class="font-sans-secondary">{{ $t('faqstepthreebold') }}</strong> {{ $t('faqstepthreetext') }}</p>
                </div>
                <div>
                    <h2 class="text-base font-sans-secondary mb-2.5">{{ $t('faqstepfourtitle') }}</h2>
                    <p class="text-base font-sans-primary"><strong class="font-sans-secondary">{{ $t('faqstepfourbold') }}</strong> {{ $t('faqstepfourtext') }}</p>
                </div>
            </div>
          </div>
          <!-- <pulse-loader :loading="loading" color="#223672" size="15px" class="fixed transform -translate-y-1/2 -translate-x-1/2 left-1/2 top-1/2"></pulse-loader> -->
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DefaultHeader from "@/components/Header.vue";
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  components: {
    DefaultHeader,
    // PulseLoader
  },
  data() {
    return {
      loading: true,
      noLightGif: require('@/assets/images/gifs/NoLightAnimationv2.gif'),
    };
  },
  computed: {
    ...mapState({
      token: (state) => state.token
    })
  },
  mounted() {
    if (!window.localStorage.getItem('token')) {
      this.$router.push({ name: 'Language' });
    } else {
      this.scrollToTop(); 
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0,0);
    }
  }
};
</script>

<style lang="scss">
  .agile__track {
    scale: 0.85;
  }
  .agile__slides {
    touch-action: none;
  }
  .agile__dots {
    width: 100%;
    justify-content: center;
  }
  .agile__slides--regular {
    .agile__slide--active {
      .slideCard {
        transition: all 1s ease-in;
        // padding: 30px;
      }
    }
  }
  .agile__actions {
    margin-top: -2.0rem;
  }
  .agile__dot {
    width: 8px;
    height: 8px;
    margin-left: 8px;
    @apply bg-gray-200 rounded-full;
    &--current {
      background-color: #223672;
    }
    &:first-child {
      margin-left: 0;
    }
  }
</style>